import React, { useEffect } from 'react';
import './layout.css';
import MusicToggle from './music_toggle';
import clickSound from '../assets/click.m4a';
import { play_sound } from '../audio_settings';

const clickAudio = new Audio(clickSound);

const Layout = (props) => {
  useEffect(() => {
    const handleButtonPress = (event) => {
      const control = event.target.closest('button, input[type="range"], [data-interactive]');

      if (!control || control.disabled || control.hasAttribute('data-no-feedback')) return;

      control.animate(
        [{ scale: 1 }, { scale: 0.92 }, { scale: 1.05 }, { scale: 1 }],
        { duration: 220, easing: 'ease-out' }
      );

      play_sound(clickAudio);
    };

    document.addEventListener('pointerdown', handleButtonPress);
    return () => document.removeEventListener('pointerdown', handleButtonPress);
  }, []);

  return (
    <div className="layout">
      <MusicToggle hidden={props.hide_music} />
      <div className="layout_screen">
        {props.children}
      </div>
    </div>
  );
}

export default Layout;
